import * as React from 'react';
import { ContentWrapper } from '../../uiComponents/layout/ContentWrapper';
import { SectionGroup } from '../../uiComponents/layout/SectionGroup';
import SectionAfsnit from '../../uiComponents/layout/SectionAfsnit';
import { Broedtekst } from '../../uiComponents/layout/Broedtekst';
import LogbogAfsnitContent from './LogbogAfsnitContent';
import { DetailedLogbog } from '../../models/DetailedLogbog';

export interface KonkurrenceLogbogContainerProps {
    logbog: DetailedLogbog;
    createIndlaeg: any;
    updateIndlaeg: any;
}

interface KonkurrenceLogbogContainerState {
}

export default class KonkurrenceLogbogContainer extends React.Component<KonkurrenceLogbogContainerProps,
    KonkurrenceLogbogContainerState> {
    constructor(props: KonkurrenceLogbogContainerProps) {
        super(props);
    }

    getSectionAfsnit = () => {
        return this
            .props
            .logbog
            .logbogAfsnit
            .map((la, i) => {
                let dialog = this.props.logbog.logbogDialoger.find(x => x.logbogAfsnitId === la.id);
                return (
                    <SectionAfsnit key={la.id} header={la.titel} subHeader={la.beskrivelse}>
                        <LogbogAfsnitContent
                            logbogAfsnitId={la.id}
                            updateIndlaeg={this.props.updateIndlaeg}
                            createIndlaeg={this.props.createIndlaeg}
                            logbogAfsnit={la}
                            dialog={dialog}
                        />
                    </SectionAfsnit>
                );
            });
    }   

    render() {
        return (
            <div className='logbog-container'>
                <ContentWrapper className='logbog-content'>
                    <SectionGroup>
                        <SectionAfsnit header='Logbog til'>
                            <h1 className='logbog-header'>{this.props.logbog.titel}</h1>
                            <Broedtekst>
                                {this.props.logbog.beskrivelse}
                            </Broedtekst>
                        </SectionAfsnit>
                        {this.getSectionAfsnit()}
                    </SectionGroup>
                </ContentWrapper>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/konkurrence/KonkurrenceLogbogContainer.tsx